/**
 * Resolve paid-access labels from shared Inertia globalSettings.
 * Distinct from People CRM "Member" status — these rename Stripe subscriptions only.
 */
export function getSubscriptionsLabels(globalSettings) {
    const plural =
        globalSettings?.subscriptions_label?.trim() || "Subscriptions";
    const singular =
        globalSettings?.subscriptions_label_singular?.trim() || "Subscription";
    const person =
        globalSettings?.subscriptions_person_label?.trim() || "Subscriber";
    const join =
        globalSettings?.subscriptions_join_label?.trim() || "Subscribe";

    return {
        plural,
        singular,
        person,
        join,
        unsubscribe: `Cancel ${singular}`,
        keep: `Keep ${singular}`,
        activeBadge: "Active",
    };
}
